<template>
  <b-row no-gutters id="dashboar-home" class="wrapper-content w-100">
    <LmComponentLoading v-if="loading" fixed />
    <b-col cols="12" class="wrapper-content">
      <b-row class="wrapper-title-page">
        <b-col cols="10" class="d-flex  align-items-center">
          <h4 class="page-title">{{ title }}</h4>
        </b-col>
        <b-col cols="2" class="d-flex  align-items-center">
          <LmBtnUpdateContentGeneric @lmBtnUpdateContentClick="getDashboardItems"/>
        </b-col>
      </b-row>
      <b-row>
        <component
          v-for="(componentData, index) in dashItems"
          :key="index"
          :is="componentData.component"
          v-bind="componentData.prop"
          :chart-data="componentData.chartData"
          :chart-option="componentData.chartOption"
          :class="{'lm-loader': componentData.component.startsWith('LmChart') ? loading : false }"
          :showHeaderTable="true"
          :hideHeadersBelowRows="true"
        />
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import LmBtnUpdateContentGeneric from '@/components/LmBtnUpdateContentGeneric.vue'
import commonsApi from '@/api/commons'
export default {
  data () {
    return {
      dashItems: [],
      title: '',
      loading: true
    }
  },
  props: {
    listEndpointUri: {
      type: String,
      required: true
    },
    paramsMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    LmBtnUpdateContentGeneric
  },
  methods: {
    async getDashboardItems () {
      this.loading = true
      try {
        const response = await commonsApi.getItemDetail({
          path: this.listEndpointUri,
          id: this.$route.params.id,
          paramsMode: this.paramsMode
        })
        this.dashItems = response.items[0]
        if (response.hasOwnProperty('title')) {
          this.title = response.title
        } else {
          this.title = this.$t('Dashboard')
        }
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.getDashboardItems()
  }
}
</script>
